// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { AcceptInvitationData, AcceptInvitationErrors, AcceptInvitationResponses, ApproveOperationData, ApproveOperationErrors, ApproveOperationResponses, AssignMemberGroupData, AssignMemberGroupErrors, AssignMemberGroupResponses, AssignProjectGroupData, AssignProjectGroupErrors, AssignProjectGroupResponses, AuthCallbackData, AuthCallbackErrors, AuthCallbackResponses, AuthClearData, AuthClearErrors, AuthClearResponses, AuthConfigData, AuthConfigErrors, AuthConfigResponses, AuthLoginData, AuthLoginErrors, AuthLoginResponses, AuthParData, AuthParErrors, AuthParResponses, AuthRefreshData, AuthRefreshErrors, AuthRefreshResponses, AuthRevokeData, AuthRevokeErrors, AuthRevokeResponses, AuthTokenData, AuthTokenErrors, AuthTokenResponses, BillingPortalData, BillingPortalErrors, BillingPortalResponses, BillingStatusData, BillingStatusErrors, BillingStatusResponses, CliMeData, CliMeErrors, CliMeResponses, CreateAccountData, CreateAccountErrors, CreateAccountResponses, CreateClusterData, CreateClusterErrors, CreateClusterResponses, CreateGroupData, CreateGroupErrors, CreateGroupResponses, CreateProjectData, CreateProjectErrors, CreateProjectResponses, CreateProviderData, CreateProviderErrors, CreateProviderResponses, DeleteGroupData, DeleteGroupErrors, DeleteGroupResponses, DeleteProjectData, DeleteProjectErrors, DeleteProjectResponses, DeleteProviderData, DeleteProviderErrors, DeleteProviderResponses, DestroyClusterData, DestroyClusterErrors, DestroyClusterResponses, GetClusterLoginConfigData, GetClusterLoginConfigErrors, GetClusterLoginConfigResponses, GetEntitlementsData, GetEntitlementsErrors, GetEntitlementsResponses, GetInvitationData, GetInvitationErrors, GetInvitationResponses, GetOperationData, GetOperationErrors, GetOperationLogsData, GetOperationLogsErrors, GetOperationLogsResponses, GetOperationResponses, HealthData, HealthErrors, HealthResponses, InviteMemberData, InviteMemberErrors, InviteMemberResponses, ListAccountsData, ListAccountsErrors, ListAccountsResponses, ListClusterOperationsData, ListClusterOperationsErrors, ListClusterOperationsResponses, ListClusterResourcesData, ListClusterResourcesErrors, ListClusterResourcesResponses, ListClustersData, ListClustersErrors, ListClustersResponses, ListGroupProjectsData, ListGroupProjectsErrors, ListGroupProjectsResponses, ListGroupsData, ListGroupsErrors, ListGroupsResponses, ListInvitationsData, ListInvitationsErrors, ListInvitationsResponses, ListMembersData, ListMembersErrors, ListMembersResponses, ListNotificationsData, ListNotificationsErrors, ListNotificationsResponses, ListProjectGroupsData, ListProjectGroupsErrors, ListProjectGroupsResponses, ListProjectsData, ListProjectsErrors, ListProjectsResponses, ListProviderRegionsData, ListProviderRegionsErrors, ListProviderRegionsResponses, ListProvidersData, ListProvidersErrors, ListProvidersResponses, ListSessionsData, ListSessionsErrors, ListSessionsResponses, ListTimezonesData, ListTimezonesErrors, ListTimezonesResponses, ListUserSessionsData, ListUserSessionsErrors, ListUserSessionsResponses, MarkNotificationReadData, MarkNotificationReadErrors, MarkNotificationReadResponses, MarkNotificationUnreadData, MarkNotificationUnreadErrors, MarkNotificationUnreadResponses, NotificationStatusData, NotificationStatusErrors, NotificationStatusResponses, ReadinessData, ReadinessErrors, ReadinessResponses, RemoveProjectGroupData, RemoveProjectGroupErrors, RemoveProjectGroupResponses, RetryOperationData, RetryOperationErrors, RetryOperationResponses, RevokeCurrentCliSessionData, RevokeCurrentCliSessionErrors, RevokeCurrentCliSessionResponses, RevokeInvitationData, RevokeInvitationErrors, RevokeInvitationResponses, RevokeSessionData, RevokeSessionErrors, RevokeSessionResponses, RevokeUserSessionData, RevokeUserSessionErrors, RevokeUserSessionResponses, StripeWebhookData, StripeWebhookErrors, StripeWebhookResponses, UpdateAccountData, UpdateAccountErrors, UpdateAccountResponses, UpdateClusterData, UpdateClusterErrors, UpdateClusterProjectData, UpdateClusterProjectErrors, UpdateClusterProjectResponses, UpdateClusterResponses, UpdateGroupData, UpdateGroupErrors, UpdateGroupResponses, UpdateProfileData, UpdateProfileErrors, UpdateProfileResponses, UpdateProjectData, UpdateProjectErrors, UpdateProjectResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export const listAccounts = <ThrowOnError extends boolean = false>(options?: Options<ListAccountsData, ThrowOnError>): RequestResult<ListAccountsResponses, ListAccountsErrors, ThrowOnError> => (options?.client ?? client).get<ListAccountsResponses, ListAccountsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts',
    ...options
});

export const createAccount = <ThrowOnError extends boolean = false>(options: Options<CreateAccountData, ThrowOnError>): RequestResult<CreateAccountResponses, CreateAccountErrors, ThrowOnError> => (options.client ?? client).post<CreateAccountResponses, CreateAccountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const updateAccount = <ThrowOnError extends boolean = false>(options: Options<UpdateAccountData, ThrowOnError>): RequestResult<UpdateAccountResponses, UpdateAccountErrors, ThrowOnError> => (options.client ?? client).put<UpdateAccountResponses, UpdateAccountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{account}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const billingStatus = <ThrowOnError extends boolean = false>(options: Options<BillingStatusData, ThrowOnError>): RequestResult<BillingStatusResponses, BillingStatusErrors, ThrowOnError> => (options.client ?? client).get<BillingStatusResponses, BillingStatusErrors, ThrowOnError>({ url: '/accounts/{account}/billing', ...options });

export const listClusters = <ThrowOnError extends boolean = false>(options: Options<ListClustersData, ThrowOnError>): RequestResult<ListClustersResponses, ListClustersErrors, ThrowOnError> => (options.client ?? client).get<ListClustersResponses, ListClustersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{account}/clusters',
    ...options
});

export const createCluster = <ThrowOnError extends boolean = false>(options: Options<CreateClusterData, ThrowOnError>): RequestResult<CreateClusterResponses, CreateClusterErrors, ThrowOnError> => (options.client ?? client).post<CreateClusterResponses, CreateClusterErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{account}/clusters',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const destroyCluster = <ThrowOnError extends boolean = false>(options: Options<DestroyClusterData, ThrowOnError>): RequestResult<DestroyClusterResponses, DestroyClusterErrors, ThrowOnError> => (options.client ?? client).delete<DestroyClusterResponses, DestroyClusterErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{account}/clusters/{id}',
    ...options
});

export const updateCluster = <ThrowOnError extends boolean = false>(options: Options<UpdateClusterData, ThrowOnError>): RequestResult<UpdateClusterResponses, UpdateClusterErrors, ThrowOnError> => (options.client ?? client).put<UpdateClusterResponses, UpdateClusterErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{account}/clusters/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getClusterLoginConfig = <ThrowOnError extends boolean = false>(options: Options<GetClusterLoginConfigData, ThrowOnError>): RequestResult<GetClusterLoginConfigResponses, GetClusterLoginConfigErrors, ThrowOnError> => (options.client ?? client).get<GetClusterLoginConfigResponses, GetClusterLoginConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{account}/clusters/{id}/config.jsonc',
    ...options
});

export const listClusterOperations = <ThrowOnError extends boolean = false>(options: Options<ListClusterOperationsData, ThrowOnError>): RequestResult<ListClusterOperationsResponses, ListClusterOperationsErrors, ThrowOnError> => (options.client ?? client).get<ListClusterOperationsResponses, ListClusterOperationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{account}/clusters/{id}/operations',
    ...options
});

export const updateClusterProject = <ThrowOnError extends boolean = false>(options: Options<UpdateClusterProjectData, ThrowOnError>): RequestResult<UpdateClusterProjectResponses, UpdateClusterProjectErrors, ThrowOnError> => (options.client ?? client).put<UpdateClusterProjectResponses, UpdateClusterProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{account}/clusters/{id}/project',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listClusterResources = <ThrowOnError extends boolean = false>(options: Options<ListClusterResourcesData, ThrowOnError>): RequestResult<ListClusterResourcesResponses, ListClusterResourcesErrors, ThrowOnError> => (options.client ?? client).get<ListClusterResourcesResponses, ListClusterResourcesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{account}/clusters/{id}/resources',
    ...options
});

export const getEntitlements = <ThrowOnError extends boolean = false>(options: Options<GetEntitlementsData, ThrowOnError>): RequestResult<GetEntitlementsResponses, GetEntitlementsErrors, ThrowOnError> => (options.client ?? client).get<GetEntitlementsResponses, GetEntitlementsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{account}/entitlements',
    ...options
});

export const listGroups = <ThrowOnError extends boolean = false>(options: Options<ListGroupsData, ThrowOnError>): RequestResult<ListGroupsResponses, ListGroupsErrors, ThrowOnError> => (options.client ?? client).get<ListGroupsResponses, ListGroupsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{account}/groups',
    ...options
});

export const createGroup = <ThrowOnError extends boolean = false>(options: Options<CreateGroupData, ThrowOnError>): RequestResult<CreateGroupResponses, CreateGroupErrors, ThrowOnError> => (options.client ?? client).post<CreateGroupResponses, CreateGroupErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{account}/groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteGroup = <ThrowOnError extends boolean = false>(options: Options<DeleteGroupData, ThrowOnError>): RequestResult<DeleteGroupResponses, DeleteGroupErrors, ThrowOnError> => (options.client ?? client).delete<DeleteGroupResponses, DeleteGroupErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{account}/groups/{id}',
    ...options
});

export const updateGroup = <ThrowOnError extends boolean = false>(options: Options<UpdateGroupData, ThrowOnError>): RequestResult<UpdateGroupResponses, UpdateGroupErrors, ThrowOnError> => (options.client ?? client).put<UpdateGroupResponses, UpdateGroupErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{account}/groups/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listGroupProjects = <ThrowOnError extends boolean = false>(options: Options<ListGroupProjectsData, ThrowOnError>): RequestResult<ListGroupProjectsResponses, ListGroupProjectsErrors, ThrowOnError> => (options.client ?? client).get<ListGroupProjectsResponses, ListGroupProjectsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{account}/groups/{id}/projects',
    ...options
});

export const listInvitations = <ThrowOnError extends boolean = false>(options: Options<ListInvitationsData, ThrowOnError>): RequestResult<ListInvitationsResponses, ListInvitationsErrors, ThrowOnError> => (options.client ?? client).get<ListInvitationsResponses, ListInvitationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{account}/invitations',
    ...options
});

export const inviteMember = <ThrowOnError extends boolean = false>(options: Options<InviteMemberData, ThrowOnError>): RequestResult<InviteMemberResponses, InviteMemberErrors, ThrowOnError> => (options.client ?? client).post<InviteMemberResponses, InviteMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{account}/invitations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const revokeInvitation = <ThrowOnError extends boolean = false>(options: Options<RevokeInvitationData, ThrowOnError>): RequestResult<RevokeInvitationResponses, RevokeInvitationErrors, ThrowOnError> => (options.client ?? client).delete<RevokeInvitationResponses, RevokeInvitationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{account}/invitations/{id}',
    ...options
});

export const listMembers = <ThrowOnError extends boolean = false>(options: Options<ListMembersData, ThrowOnError>): RequestResult<ListMembersResponses, ListMembersErrors, ThrowOnError> => (options.client ?? client).get<ListMembersResponses, ListMembersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{account}/members',
    ...options
});

export const assignMemberGroup = <ThrowOnError extends boolean = false>(options: Options<AssignMemberGroupData, ThrowOnError>): RequestResult<AssignMemberGroupResponses, AssignMemberGroupErrors, ThrowOnError> => (options.client ?? client).put<AssignMemberGroupResponses, AssignMemberGroupErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{account}/members/{member}/group',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listNotifications = <ThrowOnError extends boolean = false>(options: Options<ListNotificationsData, ThrowOnError>): RequestResult<ListNotificationsResponses, ListNotificationsErrors, ThrowOnError> => (options.client ?? client).get<ListNotificationsResponses, ListNotificationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{account}/notifications',
    ...options
});

export const notificationStatus = <ThrowOnError extends boolean = false>(options: Options<NotificationStatusData, ThrowOnError>): RequestResult<NotificationStatusResponses, NotificationStatusErrors, ThrowOnError> => (options.client ?? client).get<NotificationStatusResponses, NotificationStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{account}/notifications/status',
    ...options
});

export const listProjects = <ThrowOnError extends boolean = false>(options: Options<ListProjectsData, ThrowOnError>): RequestResult<ListProjectsResponses, ListProjectsErrors, ThrowOnError> => (options.client ?? client).get<ListProjectsResponses, ListProjectsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{account}/projects',
    ...options
});

export const createProject = <ThrowOnError extends boolean = false>(options: Options<CreateProjectData, ThrowOnError>): RequestResult<CreateProjectResponses, CreateProjectErrors, ThrowOnError> => (options.client ?? client).post<CreateProjectResponses, CreateProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{account}/projects',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteProject = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectData, ThrowOnError>): RequestResult<DeleteProjectResponses, DeleteProjectErrors, ThrowOnError> => (options.client ?? client).delete<DeleteProjectResponses, DeleteProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{account}/projects/{id}',
    ...options
});

export const updateProject = <ThrowOnError extends boolean = false>(options: Options<UpdateProjectData, ThrowOnError>): RequestResult<UpdateProjectResponses, UpdateProjectErrors, ThrowOnError> => (options.client ?? client).put<UpdateProjectResponses, UpdateProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{account}/projects/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listProjectGroups = <ThrowOnError extends boolean = false>(options: Options<ListProjectGroupsData, ThrowOnError>): RequestResult<ListProjectGroupsResponses, ListProjectGroupsErrors, ThrowOnError> => (options.client ?? client).get<ListProjectGroupsResponses, ListProjectGroupsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{account}/projects/{id}/groups',
    ...options
});

export const removeProjectGroup = <ThrowOnError extends boolean = false>(options: Options<RemoveProjectGroupData, ThrowOnError>): RequestResult<RemoveProjectGroupResponses, RemoveProjectGroupErrors, ThrowOnError> => (options.client ?? client).delete<RemoveProjectGroupResponses, RemoveProjectGroupErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{account}/projects/{id}/groups/{group}',
    ...options
});

export const assignProjectGroup = <ThrowOnError extends boolean = false>(options: Options<AssignProjectGroupData, ThrowOnError>): RequestResult<AssignProjectGroupResponses, AssignProjectGroupErrors, ThrowOnError> => (options.client ?? client).put<AssignProjectGroupResponses, AssignProjectGroupErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{account}/projects/{id}/groups/{group}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listProviders = <ThrowOnError extends boolean = false>(options: Options<ListProvidersData, ThrowOnError>): RequestResult<ListProvidersResponses, ListProvidersErrors, ThrowOnError> => (options.client ?? client).get<ListProvidersResponses, ListProvidersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{account}/providers',
    ...options
});

export const createProvider = <ThrowOnError extends boolean = false>(options: Options<CreateProviderData, ThrowOnError>): RequestResult<CreateProviderResponses, CreateProviderErrors, ThrowOnError> => (options.client ?? client).post<CreateProviderResponses, CreateProviderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{account}/providers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteProvider = <ThrowOnError extends boolean = false>(options: Options<DeleteProviderData, ThrowOnError>): RequestResult<DeleteProviderResponses, DeleteProviderErrors, ThrowOnError> => (options.client ?? client).delete<DeleteProviderResponses, DeleteProviderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{account}/providers/{id}',
    ...options
});

export const listSessions = <ThrowOnError extends boolean = false>(options: Options<ListSessionsData, ThrowOnError>): RequestResult<ListSessionsResponses, ListSessionsErrors, ThrowOnError> => (options.client ?? client).get<ListSessionsResponses, ListSessionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{account}/sessions',
    ...options
});

export const revokeSession = <ThrowOnError extends boolean = false>(options: Options<RevokeSessionData, ThrowOnError>): RequestResult<RevokeSessionResponses, RevokeSessionErrors, ThrowOnError> => (options.client ?? client).delete<RevokeSessionResponses, RevokeSessionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{account}/sessions/{id}',
    ...options
});

export const billingPortal = <ThrowOnError extends boolean = false>(options?: Options<BillingPortalData, ThrowOnError>): RequestResult<BillingPortalResponses, BillingPortalErrors, ThrowOnError> => (options?.client ?? client).get<BillingPortalResponses, BillingPortalErrors, ThrowOnError>({ url: '/api/billing/portal', ...options });

export const authCallback = <ThrowOnError extends boolean = false>(options: Options<AuthCallbackData, ThrowOnError>): RequestResult<AuthCallbackResponses, AuthCallbackErrors, ThrowOnError> => (options.client ?? client).get<AuthCallbackResponses, AuthCallbackErrors, ThrowOnError>({ url: '/auth/callback', ...options });

export const authClear = <ThrowOnError extends boolean = false>(options?: Options<AuthClearData, ThrowOnError>): RequestResult<AuthClearResponses, AuthClearErrors, ThrowOnError> => (options?.client ?? client).post<AuthClearResponses, AuthClearErrors, ThrowOnError>({ url: '/auth/clear', ...options });

export const authConfig = <ThrowOnError extends boolean = false>(options?: Options<AuthConfigData, ThrowOnError>): RequestResult<AuthConfigResponses, AuthConfigErrors, ThrowOnError> => (options?.client ?? client).get<AuthConfigResponses, AuthConfigErrors, ThrowOnError>({ url: '/auth/config', ...options });

export const authLogin = <ThrowOnError extends boolean = false>(options?: Options<AuthLoginData, ThrowOnError>): RequestResult<AuthLoginResponses, AuthLoginErrors, ThrowOnError> => (options?.client ?? client).get<AuthLoginResponses, AuthLoginErrors, ThrowOnError>({ url: '/auth/login', ...options });

export const authPar = <ThrowOnError extends boolean = false>(options: Options<AuthParData, ThrowOnError>): RequestResult<AuthParResponses, AuthParErrors, ThrowOnError> => (options.client ?? client).post<AuthParResponses, AuthParErrors, ThrowOnError>({
    url: '/auth/par',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const authRefresh = <ThrowOnError extends boolean = false>(options: Options<AuthRefreshData, ThrowOnError>): RequestResult<AuthRefreshResponses, AuthRefreshErrors, ThrowOnError> => (options.client ?? client).post<AuthRefreshResponses, AuthRefreshErrors, ThrowOnError>({ url: '/auth/refresh', ...options });

export const authRevoke = <ThrowOnError extends boolean = false>(options: Options<AuthRevokeData, ThrowOnError>): RequestResult<AuthRevokeResponses, AuthRevokeErrors, ThrowOnError> => (options.client ?? client).post<AuthRevokeResponses, AuthRevokeErrors, ThrowOnError>({ url: '/auth/revoke', ...options });

export const authToken = <ThrowOnError extends boolean = false>(options: Options<AuthTokenData, ThrowOnError>): RequestResult<AuthTokenResponses, AuthTokenErrors, ThrowOnError> => (options.client ?? client).post<AuthTokenResponses, AuthTokenErrors, ThrowOnError>({ url: '/auth/token', ...options });

export const health = <ThrowOnError extends boolean = false>(options?: Options<HealthData, ThrowOnError>): RequestResult<HealthResponses, HealthErrors, ThrowOnError> => (options?.client ?? client).get<HealthResponses, HealthErrors, ThrowOnError>({ url: '/healthz', ...options });

export const getInvitation = <ThrowOnError extends boolean = false>(options: Options<GetInvitationData, ThrowOnError>): RequestResult<GetInvitationResponses, GetInvitationErrors, ThrowOnError> => (options.client ?? client).get<GetInvitationResponses, GetInvitationErrors, ThrowOnError>({ url: '/invitations/{id}', ...options });

export const acceptInvitation = <ThrowOnError extends boolean = false>(options: Options<AcceptInvitationData, ThrowOnError>): RequestResult<AcceptInvitationResponses, AcceptInvitationErrors, ThrowOnError> => (options.client ?? client).post<AcceptInvitationResponses, AcceptInvitationErrors, ThrowOnError>({
    url: '/invitations/{id}/accept',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const cliMe = <ThrowOnError extends boolean = false>(options?: Options<CliMeData, ThrowOnError>): RequestResult<CliMeResponses, CliMeErrors, ThrowOnError> => (options?.client ?? client).get<CliMeResponses, CliMeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/me',
    ...options
});

export const updateProfile = <ThrowOnError extends boolean = false>(options: Options<UpdateProfileData, ThrowOnError>): RequestResult<UpdateProfileResponses, UpdateProfileErrors, ThrowOnError> => (options.client ?? client).put<UpdateProfileResponses, UpdateProfileErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const markNotificationRead = <ThrowOnError extends boolean = false>(options: Options<MarkNotificationReadData, ThrowOnError>): RequestResult<MarkNotificationReadResponses, MarkNotificationReadErrors, ThrowOnError> => (options.client ?? client).post<MarkNotificationReadResponses, MarkNotificationReadErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notifications/{id}/read',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const markNotificationUnread = <ThrowOnError extends boolean = false>(options: Options<MarkNotificationUnreadData, ThrowOnError>): RequestResult<MarkNotificationUnreadResponses, MarkNotificationUnreadErrors, ThrowOnError> => (options.client ?? client).post<MarkNotificationUnreadResponses, MarkNotificationUnreadErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/notifications/{id}/unread',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getOperation = <ThrowOnError extends boolean = false>(options: Options<GetOperationData, ThrowOnError>): RequestResult<GetOperationResponses, GetOperationErrors, ThrowOnError> => (options.client ?? client).get<GetOperationResponses, GetOperationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/operations/{id}',
    ...options
});

export const approveOperation = <ThrowOnError extends boolean = false>(options: Options<ApproveOperationData, ThrowOnError>): RequestResult<ApproveOperationResponses, ApproveOperationErrors, ThrowOnError> => (options.client ?? client).post<ApproveOperationResponses, ApproveOperationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/operations/{id}/approve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getOperationLogs = <ThrowOnError extends boolean = false>(options: Options<GetOperationLogsData, ThrowOnError>): RequestResult<GetOperationLogsResponses, GetOperationLogsErrors, ThrowOnError> => (options.client ?? client).get<GetOperationLogsResponses, GetOperationLogsErrors, ThrowOnError>({ url: '/operations/{id}/logs', ...options });

export const retryOperation = <ThrowOnError extends boolean = false>(options: Options<RetryOperationData, ThrowOnError>): RequestResult<RetryOperationResponses, RetryOperationErrors, ThrowOnError> => (options.client ?? client).post<RetryOperationResponses, RetryOperationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/operations/{id}/retry',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listProviderRegions = <ThrowOnError extends boolean = false>(options: Options<ListProviderRegionsData, ThrowOnError>): RequestResult<ListProviderRegionsResponses, ListProviderRegionsErrors, ThrowOnError> => (options.client ?? client).get<ListProviderRegionsResponses, ListProviderRegionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/providers/{kind}/regions',
    ...options
});

export const readiness = <ThrowOnError extends boolean = false>(options?: Options<ReadinessData, ThrowOnError>): RequestResult<ReadinessResponses, ReadinessErrors, ThrowOnError> => (options?.client ?? client).get<ReadinessResponses, ReadinessErrors, ThrowOnError>({ url: '/readyz', ...options });

export const listUserSessions = <ThrowOnError extends boolean = false>(options: Options<ListUserSessionsData, ThrowOnError>): RequestResult<ListUserSessionsResponses, ListUserSessionsErrors, ThrowOnError> => (options.client ?? client).get<ListUserSessionsResponses, ListUserSessionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/sessions',
    ...options
});

export const revokeCurrentCliSession = <ThrowOnError extends boolean = false>(options: Options<RevokeCurrentCliSessionData, ThrowOnError>): RequestResult<RevokeCurrentCliSessionResponses, RevokeCurrentCliSessionErrors, ThrowOnError> => (options.client ?? client).delete<RevokeCurrentCliSessionResponses, RevokeCurrentCliSessionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/sessions/current',
    ...options
});

export const revokeUserSession = <ThrowOnError extends boolean = false>(options: Options<RevokeUserSessionData, ThrowOnError>): RequestResult<RevokeUserSessionResponses, RevokeUserSessionErrors, ThrowOnError> => (options.client ?? client).delete<RevokeUserSessionResponses, RevokeUserSessionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/sessions/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listTimezones = <ThrowOnError extends boolean = false>(options?: Options<ListTimezonesData, ThrowOnError>): RequestResult<ListTimezonesResponses, ListTimezonesErrors, ThrowOnError> => (options?.client ?? client).get<ListTimezonesResponses, ListTimezonesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/timezones',
    ...options
});

export const stripeWebhook = <ThrowOnError extends boolean = false>(options: Options<StripeWebhookData, ThrowOnError>): RequestResult<StripeWebhookResponses, StripeWebhookErrors, ThrowOnError> => (options.client ?? client).post<StripeWebhookResponses, StripeWebhookErrors, ThrowOnError>({
    bodySerializer: null,
    url: '/webhooks/stripe',
    ...options,
    headers: {
        'Content-Type': 'application/octet-stream',
        ...options.headers
    }
});
